import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import { GetNotificationList, getNotificationCounterClear, sseTicketId, MarkAsRead, notificationCounter } from "../../actions/globalAction";
import Popup from "semantic-ui-react/dist/es/modules/Popup";
import { Link } from "react-router-dom";
import moment from "moment";
import { ReactComponent as ImageHolder } from "../../assets/svg/profile-user.svg";
import notificationSound from "../../assets/sounds/notification.mp3";
import { highlightNotifcationContent } from "../MainContent/SMR/utils";
import NotificationSettings from "../../components/MainContent/Notifications/NotificationSettings";

const NotificationModal = (props) => {
    const [profilePopOn, profileDropDownChange] = useState("hover");
    const dispatch = useDispatch();
    const browserHistory = useHistory();
    const sseData = useSelector((state) => state.globalReducer.sseData);
    const sseTicket = useSelector((state) => state.globalReducer.sseTicket);
    const listNotifications = useSelector((state) => state.globalReducer.listNotifications).slice(0, 10);
    const userTimeZone = useSelector((state) => state.globalReducer.company.user_timezone_name);
    const notificationModalClick = useSelector((state) => state.globalReducer.notificationModalClick);
    const [playNotificationSound, setPlayNotificationSound] = useState(false);
    const [counter, setCounter] = useState(+props.notificationCounter?.total || 0);

    useEffect(() => {
        dispatch(GetNotificationList(0));
    }, []);

    useEffect(() => {
        if (sseData.params?.update_counter) {
            setCounter((prev) => prev + 1);
            setPlayNotificationSound(true);
        }
    }, [sseData]);

    useEffect(() => {
        let audio;
        const isNotificationSoundEnabled = localStorage.getItem("notificationSoundEnabled") === "true";
        if (playNotificationSound && isNotificationSoundEnabled) {
            if (!audio || audio.ended) {
                audio = new Audio(notificationSound);
                audio.preload = "auto";
                audio.addEventListener("canplay", () => {
                    audio.play().then(() => {
                        setPlayNotificationSound(false);
                    });
                });
            }
        }
    }, [playNotificationSound]);

    useEffect(() => {
        if (sseTicket) {
            browserHistory.push("/social-response/inbox");
        }
    }, [sseTicket]);

    useEffect(async () => {
        if (profilePopOn == "click") {
            await setCounter(0);
            await dispatch(getNotificationCounterClear());
            await dispatch(GetNotificationList(0));
        }
    }, [profilePopOn]);

    useEffect(async () => {
        await dispatch(GetNotificationList(0));
    }, [counter]);

    const onMarkRead = (element) => {
        // let notificationList = this.state.notificationList;
        // const checkedItems = notificationList.filter((i) => i.is_viewed);

        // let count = checkedItems.length;

        // checkedItems.length &&
        //     checkedItems.forEach((element) => {
        let bodyObj = {
            is_viewed: 1,
        };

        dispatch(MarkAsRead(bodyObj, element.id, 0, "Marked Read"));
        // count--;
        // });
        // this.setState({
        //     deleteAllEnabled: false,
        //     isDeleteAllChecked: false,
        // });
    };

    const getAccountOptions = () => {
        if (profilePopOn === "click")
            return (
                <>
                    <div className="notification-wrapper">
                        {listNotifications.length > 0 ? (
                            listNotifications.map((item, index) => {
                                let time = moment(item.created_at).format("MMMM-Do-YYYY");
                                let current_time = moment(new Date()).format("MMMM-Do-YYYY");
                                let isCurrentDate = current_time === time ? true : false;
                                let dataListObject = JSON.parse(item.data);
                                let pageName = dataListObject.description?.split(":")[0];
                                let message = dataListObject.description?.split(":")[1];
                                // console.log("firstdataListObject", dataListObject,item);
                                const redirectToTicket = async () => {
                                    await onMarkRead(item);

                                    if (["smr_ticket_assigned", "smr_ticket_mentioned"].includes(item.notification_name))
                                        await dispatch(sseTicketId(dataListObject.params.ticket_id));
                                    else if (dataListObject?.action_link) props.history.push(dataListObject.action_link);
                                    // await dispatch(GetNotificationList(0));
                                    // window.location.href = "./social-response/inbox";
                                };

                                return (
                                    <div
                                        key={index}
                                        className="Render-Wrapper"
                                        style={
                                            item.is_viewed === 0
                                                ? { backgroundColor: "#EDF7FF", color: "#112C5A" }
                                                : {
                                                      color: "#697384",
                                                  }
                                        }
                                        onClick={redirectToTicket}>
                                        <div className="Notification-Render-Item">
                                            <div className="image-section">
                                                {dataListObject && dataListObject.icon ? (
                                                    <img
                                                        src={dataListObject.icon}
                                                        style={{
                                                            height: "32px",
                                                            width: "32px",
                                                            borderRadius: "114px",
                                                        }}
                                                    />
                                                ) : (
                                                    <ImageHolder />
                                                )}
                                            </div>
                                            <div className="Message-Notification">
                                                <div>{dataListObject.content}</div>
                                                <div className="description">
                                                    {/* {pageName && <span className="pageName">{`PageName: ${pageName}`}</span>}
                                                    {message && <span className="message">{`Message: ${message}`}</span>} */}
                                                    {/* <span className="message">{dataListObject.description}</span> */}
                                                    <span
                                                        className="message"
                                                        dangerouslySetInnerHTML={{ __html: highlightNotifcationContent(dataListObject.description) }}></span>
                                                </div>
                                            </div>
                                        </div>
                                        <p className="date-value">
                                            <Popup
                                                trigger={
                                                    <span>
                                                        {" "}
                                                        {isCurrentDate
                                                            ? moment(item.created_at).tz(userTimeZone).format("h:mm A")
                                                            : moment(item.created_at).tz(userTimeZone).format("MMMM Do")}
                                                    </span>
                                                }
                                                content={moment(item.created_at).tz(userTimeZone).format("llll")}
                                                size="mini"
                                                position="right center"
                                                inverted
                                            />
                                        </p>
                                    </div>
                                );
                            })
                        ) : (
                            <div className="no-data-value">
                                <span className="first">No New Notification</span>
                                <span className="second">Cluster Cleared! We’ll notify you when there is something new.</span>
                            </div>
                        )}
                    </div>

                    {/* {listNotifications.length > 0 && ( */}
                    <Link to="/notification" className="load-more-notificationModal" onClick={() => profileDropDownChange("hover")}>
                        <span className="account-text">See More</span>
                    </Link>
                    {/* // )} */}
                </>
            );
        else return <div style={{ display: "none" }}></div>;
    };
    return (
        <>
            <Popup
                className="accPopup skiptranslate"
                trigger={
                    <div className="profilePic profile_step1" onClick={() => profileDropDownChange("click")}>
                        <>
                            <div className={`notification-modal ${counter > 0 ? "active" : ""}`}>
                                <span className="material-icons notification_step1">notifications</span>
                                {counter > 0 ? (
                                    <div className="notif-counter">
                                        <p className="counter-text">{counter}</p>
                                    </div>
                                ) : null}
                            </div>
                            {/* <img src={props.companyPic} alt="company Photo" /> */}
                        </>
                    </div>
                }
                on={"click"}
                onClose={() => profileDropDownChange("hover")}
                content={getAccountOptions()}
                position="bottom right"
                // hideOnScroll
                inverted={profilePopOn === "hover"}
                size={profilePopOn === "hover" ? "tiny" : "small"}
            />
        </>
    );
};
export default NotificationModal;
